import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@/modules/components/Box'
import Link from '@/modules/components/Link'
import Typography from '@/modules/components/Typography'

import type { NavLinkBlock } from '../data/types'
import MobileMenuItem from './MobileMenuItem'

const MobileMenu = ({ menuData }: { menuData: NavLinkBlock[] }) => {
  const { t } = useTranslation('navigation')
  const [expandedIndex, setExpandedIndex] = useState(null)

  const handleMenuItemClick = (i: number) => () => {
    if (i === expandedIndex) {
      setExpandedIndex(null)
      return
    }
    setExpandedIndex(i)
  }

  const renderSubmenuItem = ({
    tTitle,
    href,
  }: {
    tTitle: string
    href: string
  }) => (
    <Link href={href}>
      <Typography variant="textCta2" color="secondaryLightGrey">
        {t(tTitle)}
      </Typography>
    </Link>
  )

  return (
    <>
      {menuData.map(({ tTitle, tBadgeTitle, href, items }, i) => {
        return (
          <Box key={tTitle} mb={i !== menuData.length - 1 ? 4 : 0}>
            <MobileMenuItem
              title={t(tTitle) as string}
              badgeTitle={t(tBadgeTitle) as string}
              href={href}
              content={
                items?.length > 0 && (
                  <Box pt={3}>
                    {items.map((item, i) => (
                      <Box
                        key={item.tTitle}
                        mb={i !== items.length - 1 ? 2 : 0}
                      >
                        {renderSubmenuItem(item)}
                      </Box>
                    ))}
                  </Box>
                )
              }
              isExpanded={expandedIndex === i}
              onClick={handleMenuItemClick(i)}
            />
          </Box>
        )
      })}
    </>
  )
}

export default MobileMenu
